export default __webpack_public_path__ + "static/media/linkedin.2d87a8a7.ico";